// Components
import ToastItemProduct from '../ToastItemProduct';

// Styles
import styles from './index.module.sass';

export default function ToastProductAdded({ addedArray }) {
  return (
    <div className={styles.arrayItems}>
      {addedArray.map((val, key) => {
        return <ToastItemProduct key={key} item={val} />;
      })}
    </div>
  );
}
